const MLBFrame = ({ type = "header", team = "mlb", noLinks = false }) => {
  const src = `https://www.mlb.com/${team}/third-party-${type}/?no_links=${noLinks}`;
  const height = type === "header" ? 56 : 281;

  const footerStyleOverride =
    type === "footer" ? { bottom: 0, position: "fixed" } : {};

  return (
    <div
      style={{
        width: "100%",
        height: `${height}px`,
        overflow: "hidden",
        border: "none",
        margin: 0,
        padding: 0,
        zIndex: 99,
        ...footerStyleOverride,
      }}
      id={`mlb-${type}`}
    >
      <iframe
        src={src}
        title={`MLB ${type}`}
        width="100%"
        height={height}
        style={{
          border: "none",
          overflow: "hidden",
          width: "100%",
          height: `${height}px`,
          display: "block",
        }}
        scrolling="no"
        frameBorder="0"
      />
    </div>
  );
};

export default MLBFrame;
